import React, { useState, useEffect, useRef } from "react";
import { BlobServiceClient } from "@azure/storage-blob";
import { ICONS } from "../utils/assets";
import ProgressBar from "./ProgressBar";
import { useDetailsStore } from "../stores/details-store";

export const UploadFile = ({ onFileUpload }) => {
  const { files, setFiles } = useDetailsStore();
  const [uploadStatus, setUploadStatus] = useState("");
  const [progress, setProgress] = useState(0);
  const [progressColor, setProgressColor] = useState("primary");
  const [userName, setUsername] = useState("");
  const fileInputRef = useRef(null);

  useEffect(() => {
    const details = JSON.parse(sessionStorage.getItem("LS_DETAILS")) || {};

    getCustomerEmail();

    if (details.documents) {
      setFiles(details.documents);
    }
  }, []);

  useEffect(() => {
    if (files.length) {
      updateLocalStorage();
    }
  }, [files]);

  const updateLocalStorage = async () => {
    const details = JSON.parse(sessionStorage.getItem("LS_DETAILS")) || {};
    sessionStorage.setItem(
      "LS_DETAILS",
      JSON.stringify({
        ...details,
        documents: files,
      })
    );
  };

  async function getCustomerEmail() {
    let { email } = JSON.parse(sessionStorage.getItem("LS_CUSTOMER_INFO"));

    if (!email) {
      email = "no-email";
    } else {
      var userEmail = email.replace("@", "AT");
      setUsername(`${userEmail}-`);
    }
  }
  //sv=2022-11-02&ss=b&srt=sco&sp=rwdlaciytfx&se=2027-12-12T18:58:58Z&st=2024-12-12T10:58:58Z&spr=https&sig=Febf2YPS76FHBPdPRtCG2yurzdfSymUABpsAvJOsTLA%3D"
  const sasToken =
    "sv=2022-11-02&ss=b&srt=sco&sp=rwdlaciytfx&se=2027-12-14T21:44:22Z&st=2024-12-14T13:44:22Z&spr=https&sig=CCfIASwXid6T7GljdJW%2FrNBKgLhMPCxzCGGFBAIadGw%3D"; // Replace with your SAS token
  const storageAccountName = "quickmovestorage"; // Replace with your Storage Account name
  const containerName = "quickmove-files"; // Replace with your container name

  // Supported file type and size limit (in bytes)
  const allowedFileTypes = [
    "application/pdf",
    "image/jpg",
    "image/jpeg",
    "image/png",
  ];
  const maxFileSize = 5 * 1024 * 1024; // 5 MB

  const handleFileClick = (e) => {
    fileInputRef.current.click();
  };

  const handleFileChange = async (event) => {
    let selectedFiles = [...event.target.files];

    if (selectedFiles) {
      setUploadStatus("Uploading...");

      if (!selectedFiles.some((file) => allowedFileTypes.includes(file.type))) {
        setUploadStatus(
          "Unsupported file type. Please upload a PDF, JPG, JPEG OR PNG file."
        );
        selectedFiles = null;
        return;
      }

      if (selectedFiles.some((file) => file.size > maxFileSize)) {
        setUploadStatus(
          "File size exceeds 5 MB limit. Please upload a smaller file."
        );
        selectedFiles = null;
        return;
      }

      await uploadFile(selectedFiles);
    }
  };

  const uploadFile = async (selectedFiles) => {
    if (!selectedFiles) {
      setUploadStatus("Please select a file first.");
      return;
    }

    try {
      setUploadStatus("Uploading...");
      setProgress(0);
      setProgressColor("primary");
      const blobStorageFilePaths = [];

      // Create a BlobServiceClient
      const blobServiceClient = new BlobServiceClient(
        `https://${storageAccountName}.blob.core.windows.net?${sasToken}`
      );

      // Get a reference to the container
      const containerClient =
        blobServiceClient.getContainerClient(containerName);

      const promises = selectedFiles.map((file, index) => {
        const timestamp = new Date().getTime();

        const fileType = file.type.split("/")[1];
        const fileName = `documents/${userName}${index}${timestamp}.${fileType}`;
        blobStorageFilePaths.push(fileName);

        const blockBlobClient = containerClient.getBlockBlobClient(fileName);

        return blockBlobClient.uploadBrowserData(file, {
          onProgress: (progressEvent) => {
            const percentComplete = Math.round(
              (progressEvent.loadedBytes / file.size) * 100
            );
            setProgress(percentComplete);
          },
        });
      });

      await Promise.all(promises);

      setUploadStatus("File uploaded successfully!");
      setProgressColor("success");

      setFiles([...files, ...blobStorageFilePaths]);

      if (onFileUpload) onFileUpload();

      fileInputRef.current.value = null;
    } catch (error) {
      console.error("Error uploading file:", error);
      setUploadStatus("File upload failed. See console for details.");
      setProgressColor("error");
    }
  };

  return (
    <>
      <div className="file" onClick={(e) => handleFileClick(e)}>
        <label htmlFor="file" className="upload-document__chips">
          {files.length ? (
            files.map((_, index) => (
              <div className="chip" key={index}>
                file-{index + 1}
              </div>
            ))
          ) : (
            <span>Select your document</span>
          )}
        </label>
        <img src={ICONS.UPLOAD_FILE_ICON} alt="Upload file icon" />
        <input
          ref={fileInputRef}
          onChange={handleFileChange}
          type="file"
          id="file"
          aria-label="Upload your document"
          accept="application/pdf, image/jpeg, image/png"
          multiple
          hidden
        />
      </div>
      {progress > 0 && (
        <ProgressBar percentage={progress} color={progressColor} />
      )}
      {uploadStatus && <p className="paragraph-md">{uploadStatus}</p>}
    </>
  );
};
